import { z } from 'zod';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const tollRoadTypeOptions = [
  'UNDEFINED',
  'AlwaysAvoid',
  'AvoidIfPossible',
  'Use',
] as const;

export const tollRoadTypeSchema = createEnumSchemaPreprocessor(
  z.enum(tollRoadTypeOptions),
  tollRoadTypeOptions
);

export type TollRoadType = z.infer<typeof tollRoadTypeSchema>;
